
import { Input } from "@/components/ui/input";
import { forwardRef } from "react";

interface WeightInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  disabled?: boolean;
  hasUnsavedChanges: boolean;
  isSyncing: boolean;
  lastSyncTime: number | null;
}

export const WeightInput = forwardRef<HTMLInputElement, WeightInputProps>(({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  disabled = false,
  hasUnsavedChanges,
  isSyncing,
  lastSyncTime
}, ref) => {
  return (
    <Input
      ref={ref}
      type="number"
      min="0"
      step="0.5"
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      disabled={disabled}
      className={`h-10 border-primary/30 hover:border-primary/50 transition-all duration-200 text-white bg-white/10 pr-12 ${
        hasUnsavedChanges ? 'ring-1 ring-orange-400/50' : ''
      } ${isSyncing ? 'ring-2 ring-blue-400/50 animate-pulse' : ''} ${
        lastSyncTime && lastSyncTime < 200 ? 'ring-1 ring-primary/30' : ''
      } ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      placeholder="Peso"
    />
  );
});

WeightInput.displayName = "WeightInput";
